import { render, staticRenderFns } from "./Nuxt3Modal.vue?vue&type=template&id=556980c0&scoped=true&"
import script from "./Nuxt3Modal.vue?vue&type=script&lang=js&"
export * from "./Nuxt3Modal.vue?vue&type=script&lang=js&"
import style0 from "./Nuxt3Modal.vue?vue&type=style&index=0&id=556980c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556980c0",
  null
  
)

export default component.exports